module.exports = {
  'navigation': ['/en/navigation/','/fr/navigation/'],
  'acces': ['/en/acces_art/','/fr/acces_art/'],
};
